export default "__VITE_ASSET__DgVET9Ec__"